// extracted by mini-css-extract-plugin
export default {"loginform":"login-form_loginform__zyV+U","popup":"login-form_popup__uVnvN"};